import { render, staticRenderFns } from "./AutoApprovalTab.vue?vue&type=template&id=6a9a380c&scoped=true"
import script from "./AutoApprovalTab.vue?vue&type=script&lang=ts"
export * from "./AutoApprovalTab.vue?vue&type=script&lang=ts"
import style0 from "./AutoApprovalTab.vue?vue&type=style&index=0&id=6a9a380c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9a380c",
  null
  
)

export default component.exports